/**
 * Create UTC Date from ISOString.
 */
export const isoStringToUTCDate = (isoString) => {
  const date = new Date(isoString);
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
  );
};



// WEBPACK FOOTER //
// ./app/src/utils/dates.js